// Compare calendar days in the user's local timezone, not elapsed hours.
export function cardActivityState(value, now = new Date()) {
  if (!value) return 'missing'
  const date = /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T00:00:00`) : new Date(value)
  if (Number.isNaN(date.getTime())) return 'missing'
  const day = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
  return day < today ? 'overdue' : day === today ? 'today' : 'future'
}
